import { render, staticRenderFns } from "./group-detail.vue?vue&type=template&id=3aecb0f5&scoped=true"
import script from "./group-detail.vue?vue&type=script&lang=js"
export * from "./group-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aecb0f5",
  null
  
)

export default component.exports